import React from 'react';

const holder = {
  closeSearchInput(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.internalStateSetter('isToggled', false);
      holder.internalStateSetter('isOpen', false);
      document.removeEventListener("mousedown", holder.closeSearchInput)
    }
  }
};

export default {
  'MobilePageSearch.Wrapper.SearchButton': async ({ containerRef, inputRef }, _, internalStateSetter) => {
    await internalStateSetter('isToggled', true);

    let newContainerRef = containerRef;
    let newInputRef = inputRef;

    if (!containerRef || !inputRef) {
      newContainerRef = React.createRef(null);
      newInputRef = React.createRef(null);
      await internalStateSetter({ containerRef: newContainerRef, inputRef: newInputRef });
    }

    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = newContainerRef;

    newInputRef?.current?.children?.[0]?.children?.[0]?.children?.[0]?.focus?.()
    document.addEventListener("mousedown", holder.closeSearchInput);
  },
  'MobilePageSearch.Wrapper.FiltersButton': ({ }, outlet) => {
    outlet({ action: 'toggleFilters' });
  },

  'MobilePageSearch.Wrapper.Search.ButtonsWrapper.Search': ({ inputVal }, outlet, internalStateSetter) => {
    outlet({ action: 'set', searchTerm: inputVal })
    internalStateSetter({ inputVal: '', isOpen: false, isToggled: false });
  },
  'MobilePageSearch.Wrapper.Search.ButtonsWrapper.Close': ({ }, _, internalStateSetter) => {
    internalStateSetter('isToggled', false);
    document.removeEventListener("mousedown", holder.closeSearchInput)
  },
  'MobilePageSearch.Wrapper.Search.SearchWrapper.SearchInput': ({ value, showDropdown }, outlet, internalStateSetter) => {
    outlet({ action: 'change', searchTerm: value });
    if (value.length > 1 && showDropdown) {
      internalStateSetter({ isOpen: true });
    } else {
      internalStateSetter({ isOpen: false })
    }
  },
  'MobilePageSearch.Wrapper.Search.SearchWrapper.SearchInput(Keydown)': ({ value, key }, outlet, internalStateSetter) => {
    if (key === 'Enter') {
      outlet({ action: 'set', searchTerm: value })
      internalStateSetter({ inputVal: '', isOpen: false, isToggled: false });
    }
  },
  'MobilePageSearch.DropdownWrapper.BorderWrapper.BodyWrapper.Body.Row': ({ suggestion }, outlet, internalStateSetter) => {
    internalStateSetter({ inputVal: '', isOpen: false });
    outlet({ action: 'set', searchTerm: suggestion })
  },
  'MobilePageSearch.DropdownWrapper.BorderWrapper.BodyWrapper.Body.RecentSearchRow': ({ suggestion }, outlet, internalStateSetter) => {
    internalStateSetter({ inputVal: '', isOpen: false });
    outlet({ action: 'set', searchTerm: suggestion })
  },
  'MobilePageSearch.SearchWrapper.Close': ({ }, outlet) => {
    outlet({ action: 'set', searchTerm: '' })
  }
}